import { pushDataLayer } from "../../../Shared/utils/datalayer";
export const pushDNBDataLayer = (data)=>pushDataLayer({
        ...data,
        event: 'dnb-event'
    });
export const pushLocationEvent = (d)=>pushDataLayer({
        event: 'dnb-event',
        category: 'Location',
        ...d
    });
export const pushExpand = (label)=>pushDNBDataLayer({
        category: 'Location',
        action: 'Unfold',
        label: label
    });
export const pushTag = (label)=>pushDNBDataLayer({
        category: 'Activity tag',
        action: window.location.pathname,
        label: label
    });
export const pushReactionAction = (category)=>(title)=>(action)=>pushDNBDataLayer({
                category,
                action,
                label: title
            });
export const pushBlogReactionAction = pushReactionAction('Blog');
export const pushTranslateAction = (label)=>pushDNBDataLayer({
        category: `Translate`,
        action: `change_language`,
        label: label
    });
